











import { Component, Prop, Vue } from "vue-property-decorator";
import { sanitizeRichText } from "@/utils/sanitize";
@Component
export default class ContactHistory extends Vue {
  @Prop() private readonly contact_info!: string;

  private panel = 0;

  private get htmlContactMessage() {
    return sanitizeRichText(this.contact_info.replace(/\r?\n/g, "<br>"));
  }
}
